<template>
  <main>
    <Trail :list="[{ name: 'Projects', tag: title }]" />
    <Container class="container--main">
      <Title tag="h1">{{ title }}</Title>
      <ProjectCard
        v-for="(project, index) in filteredProjects.data"
        :key="index"
        :title="project.title"
        :abstract="project.abstract"
        :team="project.team"
        :image="project.image"
        :path="project.path"
      />
    </Container>
  </main>
</template>
<script>
import { getProjects } from "@/projects.js";
import { useRoute } from "vue-router";
import Container from "@/components/ui/objects/Container";
import Title from "@/components/ui/atoms/Title";
import Trail from "@/components/common/Trail";

import { reactive, ref, watch } from "vue";
import ProjectCard from "@/components/ui/objects/ProjectCard";

export default {
  components: {
    Trail,
    Container,
    Title,
    ProjectCard
  },
  emits: ["setOverlay"],
  setup(props, { emit }) {
    const filter = ref("");
    const type = useRoute().params.type;
    const allProjects = getProjects(process.env.VUE_APP_PREFIX);
    const singleTypeProjects = allProjects.find(
      projects => projects.slug == type
    );
    const title =
      (singleTypeProjects && singleTypeProjects.type) ||
      `No se encontraron los proyectos ${type}`;
    const projectTypes = [];
    allProjects.forEach(e => {
      projectTypes.push({ slug: e.slug, title: e.type });
    });

    let showModal = ref(false);
    let showProject = reactive({ data: {} });
    const openModal = project => {
      showModal.value = true;
      showProject.data = project;
    };
    const close = () => {
      showModal.value = false;
    };

    let filteredProjects =
      (singleTypeProjects && reactive({ data: singleTypeProjects.data })) || [];
    const getQuery = query => {
      filter.value = query;
      filterProjects();
    };
    function filterProjects() {
      filteredProjects.data = singleTypeProjects.data.filter(project =>
        project.title.toLowerCase().includes(filter.value.toLowerCase())
      );
    }

    watch(showModal, () => {
      emit("setOverlay", showModal.value);
    });

    return {
      title,
      filteredProjects,
      showModal,
      showProject,
      openModal,
      close,
      projectTypes,
      type,
      getQuery
    };
  }
};
</script>
